import React from 'react';
import { useTranslation } from 'react-i18next';

import { TOrchestratorStatusChipProps } from '@/console/features/orchestrators/components/orchestrator-status-chip/orchestrator-status-chip.types';
import { getOrchestratorStatusDescriptor } from '@/console/features/orchestrators/utils/orchestrator-status';
import { Chip } from '@/shared/components/ui/chip/chip';

export const OrchestratorStatusChip: React.FC<TOrchestratorStatusChipProps> = ({
  orchestrator,
}) => {
  const { t } = useTranslation();

  const { chipStatus, labelKey, labelFallback } =
    getOrchestratorStatusDescriptor(
      orchestrator.status,
      orchestrator.agentVersion,
    );

  return (
    <Chip
      status={chipStatus}
      label={t(labelKey, { defaultValue: labelFallback })}
    />
  );
};
